import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";

export type DashboardUser = {
    id: number;
    username: string;
    displayName: string;
};

@Injectable()
export class DashboardService {
    readonly user$: Observable<DashboardUser>;
    private readonly authenticationService = inject(AuthenticationService);
    private readonly authenticatedUser$: Observable<DashboardUser> = this.authenticationService.userLogin.pipe(
        map(user => ({
            id: 0,
            username: user.userName,
            displayName: user.fullUserName
        }))
    );
    private readonly userSrc = new BehaviorSubject<DashboardUser>(null);

    constructor() {
        this.user$ = combineLatest([
            this.authenticatedUser$,
            this.userSrc
        ]).pipe(
            map(([authenticatedUser, user]) => user ?? authenticatedUser),
            shareReplay(1)
        );
    }

    setUser(user: DashboardUser): void {
        this.userSrc.next(user);
    }
}
